export const dropdownIcon = {
  width: 20,
  height: 20,
};

export const userInfoContainer = {
  width: "100%",
  py: 1,
  px: 2,
};

export const userInfoBox = {
  display: "flex",
  alignItems: "center",
};

export const userAvatar = {
  mr: 2,
};

export const menuItem = (theme) => ({
  color: theme.palette.text.primary,
  "&:hover": {
    backgroundColor: theme.palette.background.subtle,
  },
});
